import {
  DataService,
  TypedBaseListComponent,
  SharedModule,
  NotificationService,
  ModalService,
} from "@bb-vendure/admin-ui/core";

import { Component } from "@angular/core";
import {
  GetPackageReviewSummaryProductsDocument,
} from "src/generated-gql/graphql";
import { Observable } from "rxjs";
import { DataTable2Component } from "./custom-table/data-table2.component";
import ExpandingDivComponent from "./custom-table/components/expand_div/expand.component";
import PackageReviewOrderExpandContent from "./expand-content/content.component";
@Component({
  templateUrl: "package-review-summary-table.component.html",
  styleUrl: "package-review-summary-table.component.scss",
  standalone: true,
  imports: [
    SharedModule,
    DataTable2Component,
    ExpandingDivComponent,
    PackageReviewOrderExpandContent,
  ],
})
export class PackageReviewSummaryListComponent extends TypedBaseListComponent<
  typeof GetPackageReviewSummaryProductsDocument,
  "packageReviewSummaryProducts"
> {
  activeRowId$: Observable<string | null>;
  expandedIds: string[] = [];
  expandedRowIndex: number | null = null;
  showOrdersModal: boolean = false;
  showPackageReviewsModal: boolean = false;
  selectedProduct: any = null;
  constructor(
    protected dataService: DataService,
    private notificationService: NotificationService,
    protected modalService: ModalService
  ) {
    super();
    super.configure({
      document: GetPackageReviewSummaryProductsDocument,
      getItems: (data) => {
        return data.packageReviewSummaryProducts;
      },
      setVariables: (skip, take) => ({
        options: {
          skip,
          take,
          filter: {
            name: {
              contains: this.searchTermControl.value,
            },

            ...this.filters.createFilterInput(),
          },
          sort: this.sorts.createSortInput(),
        },
      }),
      refreshListOnChanges: [
        this.sorts.valueChanges,
        this.filters.valueChanges,
        this.searchTermControl.valueChanges,
      ],
    });
  }

  readonly filters = this.createFilterCollection().connectToRoute(this.route);

  readonly sorts = this.createSortCollection()
    .defaultSort("id", "DESC")
    .addSorts([{ name: "id" }]);

  setRowExpand(index: number) {
    if (this.expandedRowIndex === index) {
      this.expandedRowIndex = null;
    } else {
      this.expandedRowIndex = index;
    }
  }

  closeContents() {
    const params = { ...this.route.snapshot.params };
    delete params.contents;
    this.router.navigate(["./", params], {
      relativeTo: this.route,
      queryParamsHandling: "preserve",
    });
  }

  showOrdersPopup(product: any) {
    this.selectedProduct = product;
    this.showOrdersModal = true;
  }

  closeOrdersPopup() {
    this.showOrdersModal = false;
    this.selectedProduct = null;
  }

  showPackageReviewsPopup(product: any) {
    this.selectedProduct = product;
    this.showPackageReviewsModal = true;
  }

  closePackageReviewsPopup() {
    this.showPackageReviewsModal = false;
    this.selectedProduct = null;
  }
}
